/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

/*
 * Defines the Design Language System (DLS) Engine Light Icon component.
 *
 * Verified directly against the Figma "Engine Light" Alert export - always
 * Status/Red per that design (an Engine Light alert is inherently
 * critical), so the color is fixed rather than routed through `iconColor`.
 */
export const EngineLightIcon = (props: IconProps) => {
  const {iconSize} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_22062_16308)'>
        <path d='M3 10V16' stroke='#E2231A' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
        <path d='M12 5V8' stroke='#E2231A' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
        <path d='M10 5H14' stroke='#E2231A' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
        <path d='M5 13H3' stroke='#E2231A' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
        <path d='M6 10H8L10 8H13.382C13.5677 8.0001 13.7496 8.05188 13.9075 8.14955C14.0654 8.24722 14.193 8.38692 14.276 8.553L15.724 11.447C15.807 11.6131 15.9346 11.7528 16.0925 11.8504C16.2504 11.9481 16.4323 11.9999 16.618 12H18V10H20C20.2652 10 20.5196 10.1054 20.7071 10.2929C20.8946 10.4804 21 10.7348 21 11V17C21 17.2652 20.8946 17.5196 20.7071 17.7071C20.5196 17.8946 20.2652 18 20 18H18V16H15V18C15 18.2652 14.8946 18.5196 14.7071 18.7071C14.5196 18.8946 14.2652 19 14 19H10.535C10.3704 19 10.2084 18.9594 10.0632 18.8818C9.91808 18.8042 9.79435 18.6919 9.703 18.555L8 16H6V10Z' stroke='#E2231A' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
      </g>
      <defs>
        <clipPath id='clip0_22062_16308'>
          <rect width='24' height='24' rx='4' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};

export default EngineLightIcon;
